// navModel - Sprint 44 XL.
// Fuente unica de verdad para el arbol de navegacion principal.
// Agrupado por area funcional para que SidebarXL lo renderice con grupos
// colapsables y un orden logico. Los items son los mismos que hoy existen
// en src/layout/MainLayout.jsx; esto solo los reagrupa.
//
// Contrato:
//   navGroups: Array<Group>
//   Group = { id, label, items: Array<Item> }
//   Item  = { to, label, end?: boolean, icon?: string }
//
// Nota: `icon` se deja como string (nombre simbolico, sin lib externa).
// El render del icono vive en SidebarXL (glifos SVG inline o emoji fallback).
// Sprint 50 Fase 1: cambiado to:'/' -> to:'/dashboard' (item Dashboard).

export const navGroups = [
  {
    id: 'operacion',
    label: 'Operacion',
    items: [
      { to: '/',              label: 'Dashboard',     end: true, icon: 'home' },
      { to: '/inventario',    label: 'Inventario',               icon: 'boxes' },
      { to: '/productos',     label: 'Productos',                icon: 'tag' },
      { to: '/etiquetas',     label: 'Etiquetas XL',             icon: 'tag' },
      { to: '/picking',       label: 'Picking',                  icon: 'scan' },
      { to: '/packing',       label: 'Packing',                  icon: 'pkg' },
    ],
  },
  {
    id: 'importaciones',
    label: 'Importaciones',
    items: [
      { to: '/po',            label: 'Purchase Orders',          icon: 'po' },
      { to: '/grn',           label: 'GRN (Recepciones)',        icon: 'grn' },
      { to: '/importaciones', label: 'Importaciones',            icon: 'ship' },
      { to: '/couriers',      label: 'Couriers',                 icon: 'truck' },
      { to: '/proveedores',   label: 'Proveedores',              icon: 'supplier' },
    ],
  },
  {
    id: 'comercial',
    label: 'Comercial',
    items: [
      { to: '/clientes',      label: 'Clientes',                 icon: 'users' },
      { to: '/cotizaciones',  label: 'Cotizaciones',             icon: 'doc' },
      { to: '/ventas',        label: 'Ventas',                   icon: 'sale' },
      { to: '/ventas-xl',     label: 'Ventas (XL)',              icon: 'spark' },
    ],
  },
  {
    id: 'finanzas',
    label: 'Contabilidad & Finanzas',
    items: [
      { to: '/contabilidad',  label: 'Contabilidad',             icon: 'book' },
    ],
  },
  {
    id: 'admin',
    label: 'Administracion',
    items: [
      { to: '/configuracion', label: 'Configuracion',            icon: 'cog' },
    ],
  },
];

// Helper: plano (para buscar un item por ruta exacta, p.ej. para Breadcrumbs).
export function findNavItemByPath(path) {
  for (const g of navGroups) {
    for (const it of g.items) {
      if (it.to === path) return { group: g, item: it };
    }
  }
  return null;
}

export default navGroups;
